import { Component, inject, OnInit } from '@angular/core';
import { NavLink } from '../../../domain/navLinks.model';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {
  NgbCollapse,
  NgbDropdown,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle
} from '@ng-bootstrap/ng-bootstrap';

import { MsalService } from '@azure/msal-angular';
import { GraphUser } from '../../../domain/user.model';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  imports: [RouterLink, NgbCollapse, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem]
})
export class NavComponent implements OnInit {
  route = inject(ActivatedRoute);
  private msalService: MsalService = inject(MsalService);
  private appRoles = inject(AuthService);

  isMenuCollapsed: boolean;
  // @ts-ignore
  account: GraphUser;

  constructor() {
    this.isMenuCollapsed = true;
    this.account = this.msalService.instance.getAllAccounts()[0] as GraphUser;
  }

  public navLinks: NavLink[] = [
    {
      id: 1,
      text: 'Analysis',
      path: '/',
      subLinks: [
        { text: 'Overview', path: 'overview', id: 11, subLinks: [] },
        {
          text: 'Revenue Plan Day',
          path: 'revenue-plan-day',
          id: 112,
          subLinks: []
        },
        { text: 'Timeline', path: 'overview-gantt', id: 16, subLinks: [] },
        { text: 'KUR', path: 'pivot-adv-med-tg-perf', id: 17, subLinks: [] },
        { text: 'Visualisierungen', path: 'visualizations', id: 18, subLinks: [] }
      ]
    },
    {
      id: 20,
      text: 'Advertising media',
      path: '',
      subLinks: [
        { id: 21, text: 'Campaigns', path: 'campaign', subLinks: [] },
        { id: 22, text: 'Catalogue', path: 'catalogue', subLinks: [] },
        { id: 23, text: 'Mailing', path: 'mailing', subLinks: [] },
        { id: 24, text: 'Newsletter', path: 'newsletter', subLinks: [] },
        { id: 25, text: 'Event', path: 'event', subLinks: [] }
      ]
    },
    {
      id: 30,
      text: 'Purchase',
      path: '',
      subLinks: [{ text: 'Products', path: 'purchase-products', id: 34, subLinks: [] }]
    },
    {
      id: 40,
      text: 'Stammdaten',
      path: 'stammdaten',
      subLinks: [{ text: 'Event Ort', path: 'event-ort', id: 41, subLinks: [] }]
    },
    {
      id: 50,
      text: 'Sources',
      path: '',
      subLinks: [
        { text: 'Loading', path: 'loading-stand', id: 51, subLinks: [] },
        {
          text: 'Ads Costs & Clicks',
          path: 'pivot-ads-cost-clicks',
          id: 18,
          subLinks: []
        },
        {
          text: 'Maileon Overview',
          path: 'pivot-maileon-overview',
          id: 19,
          subLinks: []
        },
        {
          text: 'Matomo Last Click',
          path: 'pivot-matomo-last-click',
          id: 110,
          subLinks: []
        },
        {
          text: 'Revenue Plan Year',
          path: 'revenue-plan-year',
          id: 111,
          subLinks: []
        }
      ]
    },
    {
      id: 60,
      text: 'Plan',
      path: '',
      subLinks: [
        { text: 'Plan Periode', path: 'planperiode', id: 61, subLinks: [] },
        { text: 'Scenario', path: 'step-scenarios', id: 62, subLinks: [] },
        {
          text: 'Marketing Preview',
          path: 'marketing-preview',
          id: 63,
          subLinks: []
        },
        { text: 'Schrittbaum', path: 'step-tree', id: 64, subLinks: [] }
      ]
    },
    {
      id: 70,
      text: 'Development',
      path: '',
      subLinks: [
        { text: 'Products  Kpi', path: 'products-kpi', id: 71, subLinks: [] },
        { text: 'Products', path: 'products', id: 72, subLinks: [] },
        { text: 'Prognose', path: 'revenue-forecast', id: 73, subLinks: [] },
        { text: 'Benutzer', path: 'users', id: 74, subLinks: [] },
        {
          text: 'Szenario-Vorschau',
          path: 'step-scenario-preview',
          id: 75,
          subLinks: []
        },
        {
          text: 'Schritt-Vorschau',
          path: 'step-preview',
          id: 76,
          subLinks: []
        },
        {
          text: 'Datenquelle',
          path: 'datasources',
          id: 77,
          subLinks: []
        },
        {
          text: 'Metadateneditor',
          path: 'metadata-editor',
          id: 78,
          subLinks: []
        }
      ]
    }
  ];

  ngOnInit() {
    this.isMenuCollapsed = true;
    const roles: string[] = this.getUserRoles();
    if (!roles.includes('DEVELOPER')) {
      this.navLinks = this.navLinks.filter((link) => link.text !== 'Development');
    }
    this.navLinks = this.navLinks.filter((link) => link.text !== 'Stammdaten');
  }

  logout() {
    this.appRoles.clearStoredRoles();
    this.msalService.logoutRedirect();
  }

  collapseNavbar(): void {
    this.isMenuCollapsed = true;
  }

  private getUserRoles(): string[] {
    const roles: string | null = localStorage.getItem('roles');
    if (!roles) return [];
    return JSON.parse(roles).map((r: { name: string }): string => r.name);
  }
}
